export const orgLogo = () => {
  return (
    "/Organization" +
    "/" +
    sessionStorage.getItem("subDomain") +
    "/" +
    "Logo.svg"
  );
};
